import { Button, Modal } from "react-bootstrap";
import "./coming-soon.modal.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faClock } from "@fortawesome/free-solid-svg-icons";

interface ComingSoonProps {
    isOpen: boolean;
    onClose(): void;
    title?: string;
    onUseFreeInterview?: () => void;
}

const ComingSoonModal: React.FC<ComingSoonProps> = ({ isOpen, onClose, title = "Coming Soon", onUseFreeInterview }) => {
    return (
        <>
            <Modal show={isOpen} onHide={onClose} backdrop="static" centered>
                <Modal.Body>
                    <div className="coming-soon-control">
                        <FontAwesomeIcon icon={faClose} onClick={onClose} className="close-icon" />
                        <div className="coming-soon-content">
                            <FontAwesomeIcon icon={faClock} className="clock-icon" />
                            <h3 className="coming-soon-title">{title}</h3>
                            <p className="coming-soon-description">
                                ฟีเจอร์นี้กำลังอยู่ในระหว่างการพัฒนา<br />
                                กรุณารอติดตามการอัปเดตเร็ว ๆ นี้
                            </p>
                            <div className="button-group d-flex flex-column gap-2 w-100">
                                <Button className="button-std coming-soon-button w-100" onClick={onClose}>
                                    ตกลง
                                </Button>
                                {onUseFreeInterview && (
                                    <Button className="button-std free-interview-button w-100" onClick={onUseFreeInterview}>
                                        ใช้งานเวอร์ชั่นฟรี !
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ComingSoonModal;
